var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags.length)?_c('div',[_c('h4',{staticClass:"mb-15"},[_vm._v("Tags")]),_vm._v(" "),_c('div',_vm._l((_vm.tags),function(tag,index){return _c('a',{attrs:{"href":'/' + _vm.slugBase + '?tags='+tag.id}},[_vm._v("\n          "+_vm._s(tag.name)),(index != _vm.tags.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }